/**
 * AI.GEN lines=1-50
 * 调度系统认证相关 API
 */
import { context } from '@/common/context';
import { Request } from '@/common/context/request';

const request: Request = context.request;
const host = '';

/**
 * 用户信息响应数据
 */
export interface IInformation {
  /** HP类型权限 */
  hpType: number | null;
  /** PF类型权限 */
  pfType: number | null;
  /** 用户ID */
  userId: number | null;
  /** 用户名 */
  userName: string | null;
  /** 用户昵称 */
  userNick: string | null;
}

/**
 * 获取用户信息
 */
export const apiDispatchAuthInformation = async (): Promise<IInformation> => {
  return request.post(host + '/api/dispatch/auth/information', {});
};
